exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.details-label[data-v-55dc425e] {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  font-weight: 500;\n  font-size: 12px;\n  color: #4c5669;\n  margin-bottom: 10px;\n}\n.details-content[data-v-55dc425e] {\n  font-size: 13px;\n  color: #4c5669;\n}\n.movers-wrap[data-v-55dc425e] {\n  margin-bottom: 32px;\n}\n.fa-home[data-v-55dc425e] {\n  font-size: 26px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55dc425e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/JobDetails.vue
// module id = A1Qy
// module chunks = 0